import { render, staticRenderFns } from "./AdminPanelSettingsTab.vue?vue&type=template&id=227cb244&"
import script from "./AdminPanelSettingsTab.vue?vue&type=script&lang=js&"
export * from "./AdminPanelSettingsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports